export const colors = {
  teal: "#00838c",
  tealDark: "#006670",
  tealDeep: "#004f57",
  tealLight: "#00a89b",
  tealGhost: "#e6f5f6",
  tealFog: "#cceaec",
  navy: "#293461",
  navyDark: "#1a2245",
  navyDeep: "#0e1530",
  navyLight: "#3d4e8a",
  navyGhost: "#eceef6",
  navyFog: "#d4d8ee",
  muted: "#949ab0",
  mutedLight: "#b8bdd0",
  mutedFog: "#f0f1f6",
  mutedDeep: "#6b7290",
  white: "#ffffff",
  offWhite: "#f7f8fc",
  surface: "#f2f4f9",
  border: "#e4e7f0",
  borderLight: "#eef0f7",
  text: "#1a2040",
  textSub: "#4a5272",
  textMuted: "#949ab0",
  success: "#00838c",
  warning: "#293461",
  error: "#6b3461",
};

export const fonts = {
  semiBold: `'Open Sans', sans-serif`,
  regular: `'Open Sans', sans-serif`,
};

export const weights = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

export const radius = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  xl: "22px",
  xxl: "32px",
  full: "9999px",
};

export const shadow = {
  xs: "0 1px 3px rgba(41,52,97,.06)",
  sm: "0 2px 8px rgba(41,52,97,.08)",
  md: "0 4px 20px rgba(41,52,97,.10)",
  lg: "0 8px 36px rgba(41,52,97,.13)",
  xl: "0 16px 60px rgba(41,52,97,.16)",
  teal: "0 6px 24px rgba(0,131,140,.24)",
  navy: "0 8px 32px rgba(41,52,97,.28)",
};

export const transition = {
  fast: "all .15s ease",
  base: "all .25s ease",
  slow: "all .4s ease",
  spring: "all .35s cubic-bezier(.34,1.56,.64,1)",
};
